import type { ReactNode } from "react";
import { cn } from "./utils";

const tones = {
  neutral: "bg-muted text-fg-muted border-border",
  accent: "bg-accent-soft text-accent border-transparent",
  success: "bg-success-soft text-success border-transparent",
  warning: "bg-warning-soft text-warning border-transparent",
  danger: "bg-danger-soft text-danger border-transparent",
} as const;

export function Badge({
  children,
  tone = "neutral",
  className,
}: {
  children: ReactNode;
  tone?: keyof typeof tones;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex h-5 items-center gap-1 rounded-[5px] border px-1.5 text-[11.5px] font-medium whitespace-nowrap",
        tones[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}

export function StatusDot({
  tone,
  pulse,
}: {
  tone: "success" | "warning" | "danger" | "neutral" | "accent";
  pulse?: boolean;
}) {
  const color = {
    success: "bg-success",
    warning: "bg-warning",
    danger: "bg-danger",
    neutral: "bg-fg-subtle",
    accent: "bg-accent",
  }[tone];
  return (
    <span className={cn("inline-block size-2 shrink-0 rounded-full", color, pulse && "animate-soft-pulse")} />
  );
}
